import React from "react";
import { philosophy } from "../mock";
import { Reveal } from "../hooks/useReveal";

export default function Philosophy() {
  return (
    <section id="philosophy" className="bg-paper py-20 sm:py-28 lg:py-32">
      <div className="mx-auto max-w-2xl px-6 text-center">
        <Reveal>
          <p className="inline-block border-b border-bronze pb-2 font-sans text-[11px] uppercase tracking-[0.3em] text-ink/60">
            {philosophy.kicker}
          </p>
        </Reveal>
        <Reveal delay={100}>
          <h2 className="mt-8 font-sans text-xl font-light uppercase tracking-[0.3em] text-ink sm:text-3xl">
            {philosophy.title}
          </h2>
        </Reveal>
        <Reveal delay={200}>
          <p className="mx-auto mt-7 max-w-xl text-[14px] font-light leading-[1.9] text-ink/60">
            {philosophy.body}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
